import { Dispatch } from 'redux';
import api from '../services/api';
import { FileItem } from './../components/Downloads/Models';
import { handleError } from './dashboard';
export class DownloadsActionTypes {
  public static readonly IS_LOADING = 'IS_LOADING';
  public static readonly FETCHED_DOWNLOAD_LINK = 'FETCHED_DOWNLOAD_LINK';
  public static readonly FILE_DOWNLOADED = 'FILE_DOWNLOADED';
  public static readonly NOT_FETCHED_DOWNLOAD_LINK = 'FETCHED_DOWNLOAD_LINK';
  public static readonly FILES_FETCHED = 'FILES_FETCHED';
  public static readonly FILE_REQUESTED = 'FILE_REQUESTED';
  public static readonly FILE_FETCHED = 'FILE_FETCHED';
  public static readonly FILE_NOT_FETCHED = 'FILE_NOT_FETCHED';
  public static readonly FILE_DELETED = 'FILE_DELETED';
  public static readonly RESET = 'RESET';
  public static readonly REPORT_SENT_AGAIN = 'REPORT_SENT_AGAIN';
  public static readonly REPORT_NOT_SENT_AGAIN = 'REPORT_NOT_SENT_AGAIN';
  public static readonly TOGGLE_DOWNLOADS = 'TOGGLE_DOWNLOADS';
  public static readonly CLOSE_DOWNLOAD_NOTIFICATION =
    'CLOSE_DOWNLOAD_NOTIFICATION';
}

type responseFileObject = {
  CreatedOn: any;
  DownloadUrl: any;
  ExportUniqueID: any;
  FileName: any;
  FileType: any;
  ReportId: any;
  SchedulerExecutionId: any;
  Status: any;
  StatusDetail: any;
  UpdatedOn: any;
  UserId: number;
  id: number;
  property: any;
};

const structurizeFiles = (data: Array<responseFileObject>): Array<FileItem> => {
  let results: Array<FileItem> = [];

  if (data) {
    data.forEach((item: any, i: number) => {
      let newDate: Date | string = new Date(item.CreatedOn);
      /*
      let newDate: Date | string = Date.parse(item.CreatedOn);
      const monthNames = [
        'Jan',
        'Feb',
        'Mar',
        'Apr',
        'May',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Oct',
        'Nov',
        'Dec',
      ];

      newDate =
        String(newDate.getDay()) +
        ' ' +
        String(monthNames[newDate.getMonth()]) +
        ' ' +
        String(newDate.getFullYear()) +
        ' ' +
        String(newDate.getHours()) +
        ':' +
        String(newDate.getMinutes() < 10 ? '0' : '') +
        String(newDate.getMinutes());
        */
      const moduleName = {
        newLease: 'New Lease',
        offerCompliance: 'Offer Approval',
        tradeout: 'Rent and Occupancy',
        recommendedVsLeasePrice: 'Recommended vs Executed Price',
        availabilityReport: 'Availability Report',
      };

      if (item.Status === 'completed') {
        results.push({
          id: i,
          date:
            newDate.toDateString() +
            ' ' +
            newDate.toLocaleTimeString(navigator.language, {
              hour: '2-digit',
              minute: '2-digit',
            }),
          module: moduleName[item.ReportId] || item.ReportId,
          moduleId: String(item.ReportId),
          property: item.property,
          downloadUrl: item.DownloadUrl,
          fileId: item.id,
          ToEmail: item.ToEmail,
        });
      }
    });
  }

  return results;
};

export const fetchFiles = (clientID: any) => (dispatch: Dispatch) => {
  api
    .fetchFiles()
    .then((res: any) => {
      let results = structurizeFiles(res.data.data);

      dispatch({
        type: DownloadsActionTypes.FILES_FETCHED,
        payload: results,
        meta: {
          track: true,
        },
      });
    })
    .catch((err) => {
      console.log(err);
      handleError(err, dispatch, {
        message: 'Files not fetched',
        type: 'info',
      });
    });
};

export const closeDownloadNotification = () => (dispatch: Dispatch) => {
  dispatch({
    type: DownloadsActionTypes.CLOSE_DOWNLOAD_NOTIFICATION,
    payload: null,
    meta: {
      track: true,
    },
  });
};

export const toggleDownloads = () => (dispatch: Dispatch) => {
  dispatch({
    type: DownloadsActionTypes.TOGGLE_DOWNLOADS,
    payload: null,
    meta: {
      track: true,
    },
  });
};

export const deleteFile =
  (fileId: any, fileList: Array<FileItem>) => (dispatch: Dispatch) => {
    api
      .deleteFile(fileId)
      .then((res: any) => {
        let newFileList: Array<FileItem> = [];
        fileList.forEach((item: any) => {
          if (item.fileId !== fileId) {
            newFileList.push(item);
          }
        });

        dispatch({
          type: DownloadsActionTypes.FILE_DELETED,
          payload: newFileList,
          meta: {
            track: true,
          },
        });

        dispatch({
          type: 'SHOW_NOTIFICATIONS',
          payload: {
            message: 'File deleted sucessfully',
            type: 'success',
          },
        });
      })
      .catch((err) => {
        console.log(err);
        handleError(err, dispatch, {
          message: 'Delete file failed',
          type: 'info',
        });
      });
  };

export const generateFile =
  (id: any, clientId: any, filters: any, reportType: string = 'B') =>
  (dispatch: Dispatch) => {
    api
      .generateFile(id, clientId, filters, reportType)
      .then((res: any) => {
        dispatch({
          type: DownloadsActionTypes.FILE_REQUESTED,
          payload: { id: res.data.reportRequest.id, isSendOnEmail: false },
          meta: {
            track: true,
          },
        });
      })
      .catch((err) => {
        console.log(err);
        handleError(err, dispatch, {
          message: 'Generate file failed',
          type: 'info',
        });
      });
  };

export const sendOnEmail =
  (id: any, clientId: any, filters: any, email: any) =>
  (dispatch: Dispatch) => {
    api
      .sendOnEmail(id, clientId, filters, email)
      .then((res: any) => {
        dispatch({
          type: DownloadsActionTypes.FILE_REQUESTED,
          payload: {
            id: res.data.reportRequest.id,
            isSendOnEmail: true,
            sendTo: email,
          },
          meta: {
            track: true,
          },
        });
      })
      .catch((err) => {
        console.log(err);
        handleError(err, dispatch, {
          message: 'Generate file failed',
          type: 'info',
        });
      });
  };

export const fetchFile = (requestID: any) => (dispatch: Dispatch) => {
  api
    .fetchFile(requestID)
    .then((res: any) => {
      if (res.data.data.Status === 'completed') {
        dispatch({
          type: DownloadsActionTypes.FILE_FETCHED,
          payload: { downloadURL: res.data.data.DownloadUrl },
          meta: {
            track: true,
          },
        });
      } else if (res.data.data.Status === 'errored') {
        dispatch({
          type: DownloadsActionTypes.FILE_FETCHED,
          payload: { downloadURL: null },
          meta: {
            track: true,
          },
        });
        /*
        dispatch({
          type: 'SHOW_NOTIFICATIONS',
          payload: {
            message: 'No Data. Export file failed',
            type: 'info',
          },
        });
        */
      } else {
        dispatch({
          type: DownloadsActionTypes.FILE_NOT_FETCHED,
          payload: null,
          meta: {
            track: true,
          },
        });
      }
    })
    .catch((err) => {
      console.log(err);
      handleError(err, dispatch, {
        message: 'Generate file failed',
        type: 'info',
      });
    });
};

export const fetchFileDownload = (requestID: any) => (dispatch: Dispatch) => {
  api
    .fetchFileDownload(requestID)
    .then((res: any) => {
      dispatch({
        type: DownloadsActionTypes.FETCHED_DOWNLOAD_LINK,
        payload: res.data.url,
        meta: {
          track: true,
        },
      });
    })
    .catch((err) => {
      console.log(err);
      handleError(err, dispatch, {
        message: 'Generate file failed',
        type: 'info',
      });

      dispatch({
        type: DownloadsActionTypes.NOT_FETCHED_DOWNLOAD_LINK,
        payload: null,
        meta: {
          track: true,
        },
      });
    });
};

export const resendReport =
  (requestID: any, email: any) => (dispatch: Dispatch) => {
    api
      .resendReport(requestID, email)
      .then((res: any) => {
        dispatch({
          type: DownloadsActionTypes.REPORT_SENT_AGAIN,
          payload: null,
          meta: {
            track: true,
          },
        });
        dispatch({
          type: 'SHOW_NOTIFICATIONS',
          payload: {
            message: `Report has been sent on ${email}`,
            type: 'success',
          },
        });
      })
      .catch((err) => {
        console.log(err);
        handleError(err, dispatch, {
          message: 'Report Resend Failed',
          type: 'info',
        });

        dispatch({
          type: DownloadsActionTypes.REPORT_NOT_SENT_AGAIN,
          payload: null,
          meta: {
            track: true,
          },
        });
      });
  };

export const setFileDownloaded = () => (dispatch: Dispatch) => {
  dispatch({
    type: DownloadsActionTypes.FILE_DOWNLOADED,
    payload: null,
    meta: {
      track: true,
    },
  });
};
